// removed by extract-text-webpack-plugin
module.exports = {"ListItem":"_1eM72","ListText":"_2_2JB","ListPrice":"_1qcKN","ListItemInner":"_f46lv","Checkmark":"_Ghf6w"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Payment/Paypal/PaypalOptions/PaypalOptions.scss
// module id = 629
// module chunks = 0